import React from 'react'
import { HeroBackground } from '@/components/ui/HeroBackground'

export interface PageHeaderProps {
  title: string
  description: string
  children?: React.ReactNode
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  children
}) => {
  return (
    <section className="relative overflow-hidden px-6 pt-48 pb-4 text-center">
      <HeroBackground opacity={0.1} />
      <div className="relative z-10 mx-auto max-w-4xl">
        <h1 className="font-heading mb-4 text-4xl leading-tight md:text-5xl">
          {title}
        </h1>
        <p className="text-shire-bark mb-8 text-lg leading-relaxed md:text-xl">
          {description}
        </p>
      </div>
      {children}
    </section>
  )
}
